<template>
  <Transition name="slide-fade">
    <div v-if="!showPanel.isLeftPanel && !isImageMode" class="hidden_panel">
      <IconButtons />
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';

import IconButtons from '@/components/desktop/IconButtons.vue';
import useCommonStore from '@/store/storeCommon';

const { isImageMode } = storeToRefs(useCommonStore());
const { showPanel } = useCommonStore();
</script>

<style scoped lang="scss">
@import '@/assets/css/_colors.scss';

.hidden_panel {
  width: 67px;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: $color-white;
  position: fixed;
  z-index: 100;
}

.slide-fade-enter-active {
  transition-delay: 0.1s;
}

.slide-fade-leave-active {
  transition: 0.7s;
}
</style>